import { Link, Button, Grid, Box, Typography, Stack } from "fashion/fabrics";
import { SearchIcon } from "fashion/icons";
import CardButton from "nodes/core/CardButton";

const LINK_PREVIEW_SECRET = "https://onecommon.cards/secret";
const LINK_PREVIEW_CHEF = "https://onecommon.cards/chef";
const LINK_PREVIEW_FOREST = "https://onecommon.cards/forest";

const CARD_ID_SECRET = "bf8bf9bf-5579-40ac-8ad9-638453f8a461";
const CARD_ID_CHEF = "cd4ff140-48c8-47ed-b3ac-fc4963c07e7c";
const CARD_ID_FOREST = "af6bcce6-c903-4877-9532-614348ed069c";

const CodexCollections = () => (
  <Stack gap={3}>
    <Typography variant="h3" textAlign="center">
      Example{" "}
      <Box color="secondary.main" component="span" display="inline">
        Collections
      </Box>
    </Typography>
    <Typography color="text.secondary" textAlign="center">
      <Box color="secondary.main" component="span" display="inline">
        Create, organize and share
      </Box>{" "}
      collections or cards like these from @OneCommon.
    </Typography>
    <Grid sx={{ mt: 2 }} container rowSpacing={2} columnSpacing={2}>
      <Grid
        display="flex"
        justifyContent="center"
        size={{ xs: 12, sm: 6, md: 4 }}
      >
        <Stack sx={{ width: "100%" }} alignItems="center" gap={2}>
          <CardButton cardId={CARD_ID_FOREST} />
          <Typography color="text.secondary" variant="body2" textAlign="center">
            An{" "}
            <Box color="secondary.main" component="span" display="inline">
              Educational
            </Box>{" "}
            collection of animal species
          </Typography>
          <Button
            component={Link}
            href={LINK_PREVIEW_FOREST}
            variant="outlined"
            color="secondary"
            startIcon={<SearchIcon />}
          >
            View all 52 cards
          </Button>
        </Stack>
      </Grid>
      <Grid
        display="flex"
        justifyContent="center"
        size={{ xs: 12, sm: 6, md: 4 }}
      >
        <Stack sx={{ width: "100%" }} alignItems="center" gap={2}>
          <CardButton cardId={CARD_ID_CHEF} />
          <Typography color="text.secondary" variant="body2" textAlign="center">
            A{" "}
            <Box color="secondary.main" component="span" display="inline">
              Creator
            </Box>{" "}
            collection of homemade recipies
          </Typography>
          <Button
            component={Link}
            href={LINK_PREVIEW_CHEF}
            variant="outlined"
            color="secondary"
            startIcon={<SearchIcon />}
          >
            View all 52 cards
          </Button>
        </Stack>
      </Grid>
      <Grid
        display="flex"
        justifyContent="center"
        size={{ xs: 12, sm: 6, md: 4 }}
      >
        <Stack sx={{ width: "100%" }} alignItems="center" gap={2}>
          <CardButton cardId={CARD_ID_SECRET} />
          <Typography color="text.secondary" variant="body2" textAlign="center">
            A{" "}
            <Box color="secondary.main" component="span" display="inline">
              Business
            </Box>{" "}
            promotional cards collection
          </Typography>
          <Button
            component={Link}
            href={LINK_PREVIEW_SECRET}
            variant="outlined"
            color="secondary"
            startIcon={<SearchIcon />}
          >
            View all 12 cards
          </Button>
        </Stack>
      </Grid>
    </Grid>
  </Stack>
);

export default CodexCollections;
